export default "__VITE_ASSET__CQ3l4JOJ__"